<template>
  <div class="grid-cell">
    <router-link
      v-if="data.childTemplates > 0"
      :id="`gridCampaigns${data.id}`"
      :to="{name: 'TemplateDetailsCampaigns', query: {
        externalId: $route.query.externalId,
        clientId: $route.query.clientId,
        templateId: data.id,
        isSearchingTemplate: $route.query.isSearchingTemplate,
        isCreatingCampaign: $route.query.isCreatingCampaign,
        canCreateTemplate: $route.query.canCreateTemplate,
        userEmail: $route.query.userEmail} }"
    >
      <span class="text-campaigs">{{ data.childTemplates }}</span>
    </router-link>
    <span
      v-else
      class="text-campaigs"
    >{{ data.childTemplates }}</span>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-cell {
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  justify-content: space-evenly;
}
</style>
